import React from "react";

export const name = "Sai Nivas Mangu";

export const description =
  "Sometimes, I code. Sometimes, I make music. Other times, I sleep.";

export const priorityLink = [
  {
    link: "",
    title: "",
  },
];

export const accordianLink = [
  {
    title: "",
    description: "",
    link: "",
  },
];

export const links = [
  {
    title: "Spotify",
    description: "Check out my music on spotify",
    link: "https://open.spotify.com/artist/0Gxw6n8Pfk3ZVbgMhvu0zd",
  },
  {
    title: "Apple Music",
    description: "Check out my music on apple music",
    link: "https://music.apple.com/in/artist/sai-nivas-mangu/1552891406",
  },
  {
    title: "Most recent single",
    description: "Listen to my most recent release - when i had the chance",
    link: "https://open.spotify.com/track/5LDMfL7Hj8yQFPZ1BHV3BO?si=e80148238a374c52",
  },
  {
    title: "Michael Scott once said",
    description: "check out my playlist on spotify",
    link: "https://open.spotify.com/playlist/4rrxmpWCbYKRAXgXvKQkj3",
  },
  {
    title: "Nordic Wallpapers",
    description: "Check out this collection of wallpapers I curate",
    link: "https://nordicwallpapers.vercel.app",
  },
];

export const socials = [
  {
    amazonpay: "",
    applePay: "",
    artstation: "",
    atlassian: "",
    audible: "",
    bandcamp: "https://sainivasmangu.bandcamp.com",
    behance: "",
    bitbucket: "",
    blogger: "",
    stripe: "",
    deezer: "",
    dev: "https://dev.to/linuxdotexe",
    deviantart: "",
    dribble: "",
    flipboard: "",
    googlepay: "",
    hackerrank: "https://hackerrank.com/sainonbeat99",
    itunes: "https://music.apple.com/in/artist/sai-nivas-mangu/1552891406",
    jira: "",
    jsfiddle: "",
    mailchimp: "",
    mastodon: "",
    steam: "",
    wikipidea: "",
    whatsapp: "",
    twitch: "",
    patreon: "",
    googlePlay: "",
    paypal: "",
    slack: "",
    unsplash: "",
    codepen: "https://codepen.io/linuxdotexe",
    discord: "",
    facebook: "",
    github: "https://github.com/linuxdotexe",
    instagram: "https://instagram.com/sainivasmangu",
    linkedin: "https://linkedin.com/in/sainivasmangu",
    mail: "mailto:sainonbeat99@gmail.com",
    medium: "",
    pinterest: "",
    reddit: "",
    snapchat: "",
    telegram: "",
    tiktok: "",
    tumblr: "",
    twitter: "https://twitter.com/linuxdotexe_",
    youtube: "",
  },
];

export const embedHeading = "";

export const embeds = [
  {
    content: "",
  },
  {
    content: "",
  },
];

export const footerDesc = "";
